import { Modal, Button } from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ListGameXoso } from '~/data/dummy';
import { useTranslation } from 'react-i18next';
import { useStateContext } from '~/contexts/ContextProvider';

export default function DetailsBetRecordMobile({ data, game }) {
  const { formatMoney } = useStateContext();
  const { t } = useTranslation('report');
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const GAMES_XOCDIA = [
    {
      name: `${t('xocdia')} 30 ${t('second')}`,
      value: 30,
      type: 'xocdia',
      label: `30 ${t('second')}`,
    },
    {
      name: `${t('xocdia')} 45 ${t('second')}`,
      value: 45,
      type: 'xocdia',
      label: `45 ${t('second')}`,
    },
    {
      name: `${t('xocdia')} 60 ${t('second')}`,
      value: 60,
      type: 'xocdia',
      label: `60 ${t('second')}`,
    },
    {
      name: `${t('xocdia')} BlockChain 30 ${t('second')} - ${t('table')} A`,
      value: '30-A',
      type: 'xocdia_blockchain',
      label: `BlockChain 30 ${t('second')} - ${t('table')} A`,
    },
    {
      name: `${t('xocdia')} BlockChain 30 ${t('second')} - ${t('table')} B`,
      value: '30-B',
      type: 'xocdia_blockchain',
      label: `BlockChain 30 ${t('second')} - ${t('table')} B`,
    },
  ];
  const listGame = ListGameXoso();
  // console.log(game);

  return (
    <>
      <Button onClick={() => setOpen(true)}>{t('chi tiet')}</Button>
      <Modal
        open={open}
        closable={false}
        okText={t('xac nhan')}
        cancelText={t('dong')}
        onOk={handleClose}
        onCancel={handleClose}
        centered
        title={
          <div className="text-lg font-semibold text-center pb-1 border-b border-[#ddd]">
            {t('chi tiet')}
          </div>
        }>
        <div>
          <div className="flex justify-between">
            <span>{t('nguoichoi')}</span>
            <span>{data?.username}</span>
          </div>
          {game === 'api' && (
            <>
              <div className="flex justify-between">
                <span>{t('magame')}</span>
                <span>{data?.product}</span>
              </div>
              <div className="flex justify-between">
                <span>{t('tiencuoc')}</span>
                <p style={{ color: 'red' }}>{formatMoney(data?.bet)}</p>
              </div>
              <div className="flex justify-between">
                <span>{t('thanhtoan')}</span>
                <p style={{ color: 'green' }}>{formatMoney(data?.payout)}</p>
              </div>
              <div className="flex justify-between">
                <span>{t('doanhso')}</span>
                <p style={{ color: 'green' }}>{formatMoney(data?.tunrover || data?.bet)}</p>
              </div>
              <div className="flex justify-between">
                <span>{t('phien')}</span>
                <span>{data?.ref_no}</span>
              </div>
              <div className="flex justify-between">
                <span>{t('thoigian')}</span>
                <span>{dayjs(data?.start_time).format('HH:mm:ss DD/MM/YYYY')}</span>
              </div>
            </>
          )}
          {game !== 'api' && (
            <>
              <div className="flex justify-between">
                <span>{t('phien')}</span>
                <span>{data?.phien}</span>
              </div>
              <div className="flex justify-between">
                <span>{t('thoigian')}</span>
                <span>{dayjs(data?.created_at).format('DD/MM/YYYY HH:mm:ss')}</span>
              </div>
              <div className="flex justify-between">
                <span>{t('doanhso')}</span>
                <p style={{ color: 'green' }}>{formatMoney(data?.win)}</p>
              </div>
            </>
          )}
          {game === 'xoso' && (
            <>
              <div className="flex justify-between">
                <span>{t('theloai')}</span>
                <span>
                  {listGame?.find((item) => item.value === data.theloai)?.name || data?.theloai}
                </span>
              </div>{' '}
              <div className="flex justify-between">
                <span>{t('kieu')}</span>
                <span>{t(`${data?.type}`)}</span>
              </div>{' '}
              <div className="flex justify-between">
                <span>{t('tiencuoc')}</span>
                <p style={{ color: 'red' }}>{formatMoney(data?.amount)}</p>
              </div>{' '}
              <div className="flex justify-between">
                <span>{t('cuadat')}</span>
                <p className="max-w-[60%] text-right">
                  {JSON.parse(data?.so)
                    .map((item) => t(`${item}`))
                    .toString()
                    .replace(',', ', ')}
                </p>
              </div>{' '}
              <div className="flex justify-between">
                <span>{t('tongcuoc')}</span>
                <p style={{ color: 'green' }}>{formatMoney(data?.cuoc)}</p>
              </div>{' '}
            </>
          )}
          {game === 'sicbo' && (
            <>
              <div className="flex justify-between">
                <span>{t('theloai')}</span>
                <span>
                  {isNaN(data?.theloai) ? data?.theloai : data?.theloai + ' ' + t(`second`)}
                </span>
              </div>
              <div className="flex justify-between">
                <span>{t('cuadat')}</span>
                <span>{t(`${data?.cuadat}`)}</span>
              </div>{' '}
              <div className="flex justify-between">
                <span>{t('tiencuoc')}</span>
                <p style={{ color: 'red' }}>{formatMoney(data?.money)}</p>
              </div>
            </>
          )}
          {game === 'xocdia' && (
            <>
              <div className="flex justify-between">
                <span>{t('theloai')}</span>
                <span>
                  {GAMES_XOCDIA?.find((item) => item?.value?.toString() === data?.theloai)?.label}
                </span>
              </div>
              <div className="flex justify-between">
                <span>{t('cuadat')}</span>
                <span>{t(`xocdiadetail.${data?.cuadat}`)}</span>
              </div>{' '}
              <div className="flex justify-between">
                <span>{t('tiencuoc')}</span>
                <p style={{ color: 'red' }}>{formatMoney(data?.cuoc)}</p>
              </div>
            </>
          )}
          {game === 'xocdia_blockchain' && (
            <>
              <div className="flex justify-between">
                <span>{t('theloai')}</span>
                <span>
                  {GAMES_XOCDIA?.find((item) => item?.value?.toString() === data?.theloai)?.label}
                </span>
              </div>
              <div className="flex justify-between">
                <span>{t('cuadat')}</span>
                <span>{t(`xocdiadetail.${data?.cuadat}`)}</span>
              </div>{' '}
              <div className="flex justify-between">
                <span>{t('tiencuoc')}</span>
                <p style={{ color: 'red' }}>{formatMoney(data?.cuoc)}</p>
              </div>
            </>
          )}
          {game === 'baucua' && (
            <>
              <div className="flex justify-between">
                <span>{t('theloai')}</span>
                <span>{data?.theloai + ' ' + t(`second`)}</span>
              </div>
              <div className="flex justify-between">
                <span>{t('cuadat')}</span>
                <span>{t(`${data?.cuadat}`)}</span>
              </div>
              <div className="flex justify-between">
                <span>{t('kieu')}</span>
                <span>{t(`${data?.cachchoi}`)}</span>
              </div>{' '}
              <div className="flex justify-between">
                <span>{t('tiencuoc')}</span>
                <p style={{ color: 'red' }}>{formatMoney(data?.cuoc)}</p>
              </div>
            </>
          )}
          {game === 'rongho' && (
            <>
              <div className="flex justify-between">
                <span>{t('theloai')}</span>
                <span>{data?.theloai + ' ' + t(`second`)}</span>
              </div>
              <div className="flex justify-between">
                <span>{t('cuadat')}</span>
                <span>{t(`ronghodetail.${data?.cuadat}`)}</span>
              </div>
              <div className="flex justify-between">
                <span>{t('tiencuoc')}</span>
                <p style={{ color: 'red' }}>{formatMoney(data?.cuoc)}</p>
              </div>
            </>
          )}
        </div>
      </Modal>
    </>
  );
}
